import { z } from 'zod';

export const lensAnnotationStatesZod = z.enum([
  'On',
  'Off',
  'Blinking',
  'NotVisible',
  'Unusable',
  'Unknown',
]);
export type LensAnnotationStates = z.infer<typeof lensAnnotationStatesZod>;

export const lensAnnotationZod = z.object({
  token: z.string(),
  annotation: z.nullable(z.string()),
  state: lensAnnotationStatesZod,
  taskToken: z.string().nullable(),
  lensId: z.number().int().nonnegative(),
  frameIndex: z.number().int().nonnegative(),
  videoExtractionToken: z.string(),
  tag: z.nullable(z.string()),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export const lensAnnotationResponseZod = z.array(lensAnnotationZod);
export type LensAnnotation = z.infer<typeof lensAnnotationZod>;

export function isLensAnnotation(obj: unknown): boolean {
  return lensAnnotationZod.safeParse(obj).success;
}
